var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "07-documents",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "none",
    width: 64,
    height: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.9,9.4L45.9,9.4c0-1.2-0.5-2.3-1.3-3.2c-0.8-0.8-2-1.3-3.2-1.3c0,0-3.7,0-4.1,0l-0.1,0l-5.2,0l-5.2,0c0,0,0,0,0,0 c-0.3,0-4.1,0-4.1,0c-1.2,0-2.3,0.5-3.2,1.3c-0.8,0.8-1.3,2-1.3,3.2l0,0l0,5.2c0,0.4,0.3,0.6,0.7,0.6c0.4-0.1,0.7-0.2,1.1-0.3 c0.5-0.2,1-0.6,1.5-1c0.4-0.4,0.8-0.9,1-1.5s0.3-1.1,0.3-1.7l0-0.8c0-0.3,0.3-0.6,0.6-0.6l8.8,0l8.8,0c0.3,0,0.6,0.3,0.6,0.6l0,0.8 c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.6,1,1,1.5c0.4,0.4,0.9,0.8,1.5,1c0.3,0.1,0.7,0.2,1.1,0.3c0.4,0.1,0.7-0.2,0.7-0.6L45.9,9.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.4,18.3H38.7v4.5h14.7c2,0,3.6,1.6,3.6,3.6v24.7c0,2-1.6,3.6-3.6,3.6H10.6c-2,0-3.6-1.6-3.6-3.6V26.4 c0-2,1.6-3.6,3.6-3.6H39v-4.5H10.6c-4.5,0-8.1,3.6-8.1,8.1v24.7c0,4.5,3.6,8.1,8.1,8.1h42.9c4.5,0,8.1-3.6,8.1-8.1V26.4 C61.5,22,57.9,18.3,53.4,18.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 30,
    width: 52.5,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 34.5,
    width: 8,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.7,
    y: 34.5,
    width: 8,
    height: 4.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.7863cf029c22763f46d6c5edf0cea3e7.svg";
export { ForwardRef as ReactComponent };